/* eslint-disable indent */
import React from 'react';
// components
import GridPageAbstract from '../../GridPageAbstract';
import { LocationBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';
import i18n from '../../../i18';
import {
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    DialogActions,
    Button,
    TextField,
    CircularProgress,
    Box
} from '@mui/material';
import {
    CloseCircleCustomLinearIcon,
    DocumentTextLinearIcon,
    TickSquareCustomLinearIcon,
    HistoryLogCustomLinearIcon,
    TimerLinearIcon
} from '../../../icons-lib';

import CloseIcon from '@mui/icons-material/Close';

import DialogAbstract from './../../DialogAbstract';
import { purple } from '@mui/material/colors';
import { formatError } from '../../../utils/formatError';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/de';

export default class MerchantsLocationsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'merchantLocations';
        this.Server = this.props.context.getState().server.merchantLocations;
        this.permissionName = 'approve-merchant-location';

        this.headerStartIcon = LocationBulkIcon;
        this.bannerImage = config?.bannerImages?.locations || '';

        this.state = {
            ...this.state,
            isHistoryOpen: false,
            historyData: [],
            selectedMerchant: null,
            postSaveDialogOpen: false,
            postSaveData: null,
            modificationReason: '',
            isSubmitting: false,
            scheduleDeactivationDialogOpen: false,
            scheduledDeactivationDate: null,
            scheduledDeactivationTime: null,
            isSavingSchedule: false,
            selectedMerchantLocationId: null
        };

        this.handleHistoryLogOpen = this.handleHistoryLogOpen.bind(this);
        this.handleHistoryLogClose = this.handleHistoryLogClose.bind(this);
        this.handleMerchantSave = this.handleMerchantSave.bind(this);
        this.handleReasonChange = this.handleReasonChange.bind(this);
        this.handlePostSaveDialogClose =
            this.handlePostSaveDialogClose.bind(this);
        this.submitWithReason = this.submitWithReason.bind(this);
        this.handleScheduleDeactivationOpen =
            this.handleScheduleDeactivationOpen.bind(this);
        this.handleScheduleDeactivationClose =
            this.handleScheduleDeactivationClose.bind(this);
        this.handleScheduleDeactivationSave =
            this.handleScheduleDeactivationSave.bind(this);
        this.handleScheduleDateChange =
            this.handleScheduleDateChange.bind(this);
        this.handleScheduleTimeChange =
            this.handleScheduleTimeChange.bind(this);

        const parentGetCellValue = this.getCellValue;
        this.getCellValue = (row, field) => {
            if (
                field.id === 'dateCreated' &&
                (row.approvalState === 'pending' ||
                    row.approvalState === 'review') &&
                row.originalDateCreated
            ) {
                return row.originalDateCreated;
            }
            return parentGetCellValue(row, field);
        };

        this.exportButton = true;
        this.showHistoryFilters = true;
        this.hideDeleteAction = true;
        this.historyFieldLabels = {
            parentLabel: 'locationHistory',
            statusLabel: 'approvalState',
            dateFromLabel: 'dateFrom',
            dateToLabel: 'dateTo'
        };

        this.searchFields = [
            'name',
            'merchant.name',
            'city',
            'street',
            'zip',
            'wallets.walletNumber',
            'draftWallets.walletNumber'
        ];

        this.hiddenColumns = config?.hiddenColumns?.merchantLocations || [];

        this.Head = [
            {
                id: 'merchantId',
                sortField: 'merchant.name',
                label: 'associatedMerchant',
                alignRight: false,
                cell: 'Associated',
                associatedSettings: { primary: 'name', secondary: 'email' },
                searchType: 'server', // server, client
                searchFields: ['name', 'email'], // for server search
                searchController: 'merchants', // for server search
                from: 'merchants',
                display: 'name',
                object: 'merchant',
                filterCell: 'Context',
                filterBy: 'merchants',
                fallbackDisplay: 'email'
            },
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Translatable'
            },
            {
                id: 'walletNumber',
                label: 'walletNumber',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'email',
                label: 'email',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'accountingEmail',
                label: 'accountingEmail',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'approvalState',
                label: 'approvalState',
                alignRight: false,
                cell: 'Status',
                controller: 'merchantLocations',
                fieldIdName: 'merchantLocationId',
                items: ['pending', 'active', 'rejected', 'archived', 'review'],
                itemsWithPermission: [
                    { name: 'review', permission: 'review-merchant-location' },
                    { name: 'active', permission: 'approve-merchant-location' },
                    {
                        name: 'rejected',
                        permission: 'reject-merchant-location'
                    },
                    {
                        name: 'archived',
                        permission: 'approve-merchant-location'
                    },
                    { name: 'pending', permission: 'approve-merchant-location' }
                ],
                statusMap: {
                    pending: 'review',
                    review: 'active',
                    active: 'rejected',
                    rejected: 'archived',
                    archived: 'pending'
                },
                disableEditor: true,
                filterCell: 'Items',
                filterBy: 'approvalState',
                needTranslate: true
            },
            {
                id: 'approvedUser',
                label: 'approvedUser',
                alignRight: false,
                cell: 'Text',
                display: 'firstName+lastName',
                object: 'approvedUser',
                disableEditor: true,
                filterCell: 'Context',
                filterBy: 'users'
            },
            {
                id: 'shortDescription',
                label: 'shortDescription',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'subtitle',
                label: 'subtitle',
                alignRight: false,
                cell: 'Text'
            },
            { id: 'link', label: 'link', alignRight: false, cell: 'Text' }, //add cell: "Link" to make it a link
            {
                id: 'keywords',
                label: 'keywords',
                alignRight: false,
                cell: 'Tags'
            },
            {
                id: 'locationFiles',
                label: 'locationFiles',
                alignRight: false,
                cell: 'Upload',
                fileType: 'merchant',
                type: 'merchantUpload',
                uploadType: 'multiple',
                fileParent: 'merchantId'
            },
            {
                id: 'categories',
                label: 'categories',
                alignRight: false,
                cell: 'Array',
                display: 'name',
                from: 'merchantCategory',
                primary: 'name'
            },
            { id: 'street', label: 'street', alignRight: false, cell: 'Text' },
            { id: 'zip', label: 'zip', alignRight: false, cell: 'Text' },
            { id: 'city', label: 'city', alignRight: false, cell: 'Text' },
            {
                id: 'province',
                label: 'province',
                alignRight: false,
                cell: 'Entity',
                filterCell: 'Items',
                filterBy: 'province',
                filterField: 'province',
                items: config.provinces
            },
            {
                id: 'googlePlacesId',
                label: 'googlePlacesId',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'longitude',
                label: 'longitude',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'latitude',
                label: 'latitude',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'mobilePhone',
                label: 'mobilePhone',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }

    checkItemState = (data, state) => {
        const items = Array.isArray(data) ? data : [data];
        return items.some((item) => item.approvalState === state);
    };

    needsApprovalItems = () => {
        const selectedItems = this.List.filter((item) =>
            this.state.selected.includes(item.id)
        );
        return this.checkItemState(selectedItems, 'review');
    };
    needsReviewItems = () => {
        const selectedItems = this.List.filter((item) =>
            this.state.selected.includes(item.id)
        );
        return this.checkItemState(selectedItems, 'pending');
    };
    needsApprovalItem = () => {
        const item = this.List.find(
            (it) => it.id === this.state.menuClickItemId
        );
        return item?.approvalState === 'review';
    };
    needsReviewItem = () => {
        const item = this.List.find(
            (it) => it.id === this.state.menuClickItemId
        );
        return item?.approvalState === 'pending';
    };

    handleChangeStatus = async (status) => {
        const ids = this.state.menuClickItemId
            ? [this.state.menuClickItemId]
            : this.state.selected;
        const id = ids.length === 1 ? ids[0] : null;
        if (id) {
            await this.changeStatus({
                merchantLocationId: id,
                state: status
            });
        } else {
            await this.changeStatus({
                merchantLocationIds: ids,
                state: status
            });
        }
    };

    renderCustomMenuItems() {
        const menuItems = [
            this.allowedAction('review-merchant-location') &&
                this.needsReviewItem() && (
                    <MenuItem
                        onClick={() => this.handleReviewDialogOpen()}
                        key="review"
                    >
                        <DocumentTextLinearIcon sx={{ mr: 2 }} />
                        {i18n.t('buttons.review')}
                    </MenuItem>
                ),
            this.allowedAction('approve-merchant') && (
                <MenuItem
                    key="historyLog"
                    onClick={() => this.handleHistoryLogOpen()}
                >
                    <HistoryLogCustomLinearIcon sx={{ mr: 2 }} />
                    {i18n.t('buttons.historyLog')}
                </MenuItem>
            ),
            this.allowedAction(this.permissionName) &&
                this.needsApprovalItem() && (
                    <MenuItem
                        onClick={() => this.handleActivateDialogOpen()}
                        key="approve"
                    >
                        <TickSquareCustomLinearIcon sx={{ mr: 2 }} />
                        {i18n.t('buttons.approve')}
                    </MenuItem>
                ),
            this.allowedAction('reject-merchant-location') &&
                this.needsApprovalItem() && (
                    <MenuItem
                        onClick={() => this.handleRejectDialogOpen()}
                        key="decline"
                    >
                        <CloseCircleCustomLinearIcon sx={{ mr: 2 }} />
                        {i18n.t('buttons.decline')}
                    </MenuItem>
                ),
            this.allowedAction(this.permissionName) && (
                <MenuItem
                    onClick={() => this.handleScheduleDeactivationOpen()}
                    key="scheduleDeactivation"
                >
                    <TimerLinearIcon sx={{ mr: 2 }} />
                    {i18n.t('buttons.scheduleDeactivation')}
                </MenuItem>
            )
        ];
        return menuItems.filter(Boolean);
    }

    // New onSave for DialogAbstract
    // Open our dialog immediately, without autosave
    // When user clicks OK in reason dialog
    // Now call standard save with data + reason + modifiedBy
    // Now call base save
    // Form request body for logging
    // email: user.email, // for example, "admin2@gmail.com"
    // reason: modificationReason // for example, "test2"
    // here you can show an error to the user if you wish
    // Close our dialog
    // Override renderDialog to pass our onSave
    // Instead of super.handleDialogOnSave — our interceptor
    // Render our dialog with reason
    // This is a hook, but we'll get the theme directly from the class
    // or set it in state/props if you use ThemeProvider.
    // highlight orange if value changed
    handleMerchantSave(data) {
        // открываем наше окошко сразу, без автосохранения
        this.setState({
            postSaveDialogOpen: true,
            postSaveData: data,
            modificationReason: ''
        });
    }

    handleReasonChange(e) {
        this.setState({ modificationReason: e.target.value });
    }

    handlePostSaveDialogClose() {
        this.setState({
            postSaveDialogOpen: false,
            postSaveData: null,
            isSubmitting: false
        });
    }

    // Когда пользователь нажал OK в окне причины
    async submitWithReason() {
        this.setState({ isSubmitting: true });
        const { postSaveData, modificationReason } = this.state;
        const user = this.props.context.getState().userInfo;

        // теперь вызываем стандартный save с данными + reason + modifiedBy
        const payload = {
            ...postSaveData,
            modificationReason,
            modifiedBy: user
        };

        // теперь вызываем базовый save
        await super.handleDialogOnSave(payload);

        // формируем тело для логирования
        const logPayload = {
            email: user.email, // например, "admin2@gmail.com"
            reason: modificationReason // например, "test2"
        };

        try {
            const logRes = await fetch('/api/merchants/activity-log/latest', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': localStorage.token
                },
                body: JSON.stringify(logPayload)
            });
            if (!logRes.ok) {
                throw new Error(`Ошибка логирования: ${logRes.status}`);
            }
            const logResult = await logRes.json();
        } catch (err) {
            console.error('Не удалось записать activity-log:', err);
            // здесь по желанию можно показать ошибку пользователю
        }

        // закрываем наше окно
        this.handlePostSaveDialogClose();
    }

    // Переопределяем renderDialog, чтобы передать наш onSave
    renderDialog() {
        return (
            <DialogAbstract
                dialogOpen={this.state.dialogOpen}
                dialogData={this.state.dialogData}
                permissions={this.permissions}
                Name={this.Name}
                Head={this.Head}
                Server={this.Server}
                // вместо super.handleDialogOnSave — наш перехватчик
                onSave={this.handleMerchantSave}
                onClose={() => this.handleDialogOnClose()}
            />
        );
    }

    // Рендерим наше окно с reason
    renderPostSaveDialog() {
        const {
            postSaveDialogOpen,
            postSaveData,
            modificationReason,
            isSubmitting
        } = this.state;
        return (
            <Dialog
                open={postSaveDialogOpen}
                onClose={this.handlePostSaveDialogClose}
                fullWidth
                maxWidth="sm"
            >
                <DialogContent dividers>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Modification reason"
                        type="text"
                        fullWidth
                        value={modificationReason}
                        onChange={this.handleReasonChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handlePostSaveDialogClose}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        onClick={this.submitWithReason}
                        disabled={!modificationReason.trim() || isSubmitting}
                        startIcon={
                            isSubmitting ? <CircularProgress size={20} /> : null
                        }
                    >
                        {isSubmitting ? 'Saving...' : i18n.t('OK')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    render() {
        return (
            <>
                {super.render()}
                {this.renderPostSaveDialog()}
                {this.renderHistoryDialog()}
                {this.renderScheduleDeactivationDialog()}
            </>
        );
    }

    async handleHistoryLogOpen() {
        this.setState({
            selectedMerchant: this.state.menuClickItemId,
            isHistoryOpen: true
        });
        try {
            const res = await fetch(
                `/api/merchants/activity-log/${this.state.menuClickItemId}`,
                { headers: { 'X-Auth-Token': localStorage.token } }
            );
            const json = await res.json();
            this.setState({ historyData: json.data });
        } catch (e) {
            console.error('Failed to load history:', e);
        }
    }

    handleHistoryLogClose() {
        this.setState({ isHistoryOpen: false, historyData: [] });
    }

    renderHistoryDialog() {
        const { isHistoryOpen, historyData, selectedMerchant } = this.state;
        // Это хук, но из класса жёстко достанем тему так:
        const theme = this.props.context.theme;
        // или завести его в стейте/пропсах, если используете ThemeProvider.

        const formatDate = (iso) => {
            const d = new Date(iso);
            const time = d.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
            });
            const date = d.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
            });
            return `${time} · ${date}`;
        };

        return (
            <Dialog
                open={isHistoryOpen}
                onClose={this.handleHistoryLogClose}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle sx={{ m: 0, p: 2, fontWeight: 600, fontSize: 20 }}>
                    {i18n.t('History Log', { name: selectedMerchant?.name })}
                    <IconButton
                        aria-label="close"
                        onClick={this.handleHistoryLogClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed Field (Old)')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed Field (New)')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Date & Time')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Changed by')}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="subtitle2"
                                        color="textSecondary"
                                    >
                                        {i18n.t('Reason')}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {historyData.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        <Typography color="textSecondary">
                                            {i18n.t('historyLog.noEntries')}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}

                            {historyData.map((row) => {
                                const isChanged =
                                    row.changedFieldOld !== row.changedFieldNew;
                                return (
                                    <TableRow key={row.id}>
                                        {/* OLD */}
                                        <TableCell
                                            sx={{
                                                verticalAlign: 'top',
                                                py: 1.5
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="textSecondary"
                                                sx={{
                                                    textTransform: 'capitalize',
                                                    mb: 0.5,
                                                    display: 'block',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {row.fieldName}
                                            </Typography>

                                            {row.changedFieldOld ? (
                                                <Typography
                                                    variant="body2"
                                                    color="textPrimary"
                                                >
                                                    {row.changedFieldOld}
                                                </Typography>
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ fontStyle: 'italic' }}
                                                >
                                                    (Blank)
                                                </Typography>
                                            )}
                                        </TableCell>

                                        {/* NEW */}
                                        <TableCell
                                            sx={{
                                                verticalAlign: 'top',
                                                py: 1.5
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                color="textSecondary"
                                                sx={{
                                                    textTransform: 'capitalize',
                                                    mb: 0.5,
                                                    display: 'block',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {row.fieldName}
                                            </Typography>

                                            {row.changedFieldNew ? (
                                                <Typography
                                                    variant="body2"
                                                    // выделяем оранжевым, если значение изменилось
                                                    color={
                                                        isChanged
                                                            ? 'warning.main'
                                                            : 'textPrimary'
                                                    }
                                                >
                                                    {row.changedFieldNew}
                                                </Typography>
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{ fontStyle: 'italic' }}
                                                >
                                                    (Blank)
                                                </Typography>
                                            )}
                                        </TableCell>

                                        {/* DATE */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                {formatDate(row.dateCreated)}
                                            </Typography>
                                        </TableCell>

                                        {/* CHANGED BY */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: purple[600],
                                                    fontWeight: 500
                                                }}
                                            >
                                                {row.changedBy}
                                            </Typography>
                                        </TableCell>

                                        {/* REASON */}
                                        <TableCell sx={{ py: 1.5 }}>
                                            <Typography
                                                variant="body2"
                                                color="textPrimary"
                                            >
                                                {row.reason}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={this.handleHistoryLogClose}>
                        {i18n.t('Close')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    customRetrieveData = async (list) => {
        const files = list
            .flatMap((item) => item.locationFiles)
            .map((locationFiles) => locationFiles.file);
        await this.preloadContextImages(files);
    };

    handleScheduleDeactivationOpen() {
        const merchantLocationId = this.state.menuClickItemId;
        const item = this.List.find((it) => it.id === merchantLocationId);

        if (item && item.scheduledDeactivationDate) {
            const scheduledDate = moment(item.scheduledDeactivationDate);
            this.setState({
                scheduleDeactivationDialogOpen: true,
                scheduledDeactivationDate: scheduledDate,
                scheduledDeactivationTime: scheduledDate,
                selectedMerchantLocationId: merchantLocationId
            });
        } else {
            this.setState({
                scheduleDeactivationDialogOpen: true,
                scheduledDeactivationDate: null,
                scheduledDeactivationTime: null,
                selectedMerchantLocationId: merchantLocationId
            });
        }
        this.handleCloseMenu();
    }

    handleScheduleDeactivationClose() {
        this.setState({
            scheduleDeactivationDialogOpen: false,
            scheduledDeactivationDate: null,
            scheduledDeactivationTime: null,
            isSavingSchedule: false,
            selectedMerchantLocationId: null
        });
    }

    handleScheduleDateChange(date) {
        this.setState({ scheduledDeactivationDate: date });
        if (date && this.state.scheduledDeactivationTime) {
            // Merge date with existing time
            const merged = moment(date);
            const time = moment(this.state.scheduledDeactivationTime);
            merged.hour(time.hour());
            merged.minute(time.minute());
            merged.second(time.second());
            this.setState({ scheduledDeactivationTime: merged });
        } else if (date) {
            // Set default time if no time selected
            const defaultTime = moment(date).hour(0).minute(0).second(0);
            this.setState({ scheduledDeactivationTime: defaultTime });
        }
    }

    handleScheduleTimeChange(type, value) {
        const { scheduledDeactivationDate, scheduledDeactivationTime } =
            this.state;
        let currentDateTime =
            scheduledDeactivationTime || scheduledDeactivationDate || moment();

        if (!currentDateTime || !moment.isMoment(currentDateTime)) {
            currentDateTime = scheduledDeactivationDate || moment();
        }

        const updatedDateTime = moment(currentDateTime);

        if (type === 'hours') {
            const hours = parseInt(value, 10);
            if (!isNaN(hours) && hours >= 0 && hours <= 23) {
                updatedDateTime.hour(hours);
            }
        } else if (type === 'minutes') {
            const minutes = parseInt(value, 10);
            if (!isNaN(minutes) && minutes >= 0 && minutes <= 59) {
                updatedDateTime.minute(minutes);
            }
        }

        this.setState({
            scheduledDeactivationTime: updatedDateTime,
            scheduledDeactivationDate: updatedDateTime
        });
    }

    async handleScheduleDeactivationSave() {
        this.setState({ isSavingSchedule: true });
        const { scheduledDeactivationTime, selectedMerchantLocationId } =
            this.state;
        const merchantLocationId = selectedMerchantLocationId;

        // Validate: must have a date to save
        if (!scheduledDeactivationTime) {
            this.setState({
                isSavingSchedule: false,
                snackbarOpen: true,
                alertText: i18n.t('scheduleDeactivation.dateRequired')
            });
            return;
        }

        try {
            // Format as LocalDateTime (ISO string without timezone)
            // moment.format() uses local timezone by default, which is what we want
            // Get user's timezone (e.g., "Europe/Zurich", "America/New_York")
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            // Only send when we have a valid date
            const payload = {
                merchantLocationId: Number(merchantLocationId),
                scheduledDeactivationDate: scheduledDeactivationTime
                    .local()
                    .format('YYYY-MM-DDTHH:mm:ss'),
                timezone: timezone
            };

            const response = await fetch(
                '/api/merchant-locations/set-scheduled-deactivation',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Auth-Token': localStorage.token
                    },
                    body: JSON.stringify(payload)
                }
            );

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(
                    errorData.error || `HTTP error! status: ${response.status}`
                );
            }

            const result = await response.json();
            if (result.error && result.error !== 'OK') {
                throw new Error(result.error);
            }

            // Refresh data
            await this.retrieveData();

            // Close dialog
            this.handleScheduleDeactivationClose();
        } catch (error) {
            console.error('Failed to set scheduled deactivation:', error);
            this.setState({
                snackbarOpen: true,
                alertText: formatError(error)
            });
        } finally {
            this.setState({ isSavingSchedule: false });
        }
    }

    renderScheduleDeactivationDialog() {
        const {
            scheduleDeactivationDialogOpen,
            scheduledDeactivationDate,
            scheduledDeactivationTime,
            isSavingSchedule,
            selectedMerchantLocationId
        } = this.state;

        const locale = i18n.language === 'en' ? 'en-gb' : i18n.language;
        const item = this.List.find(
            (it) => it.id === selectedMerchantLocationId
        );

        return (
            <Dialog
                open={scheduleDeactivationDialogOpen}
                onClose={this.handleScheduleDeactivationClose}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ m: 0, p: 2, fontWeight: 600, fontSize: 20 }}>
                    {i18n.t('scheduleDeactivation.title')}
                    <IconButton
                        aria-label="close"
                        onClick={this.handleScheduleDeactivationClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    {item && item.scheduledDeactivationDate && (
                        <Typography
                            variant="body2"
                            sx={{
                                mb: 2,
                                p: 1.5,
                                bgcolor: 'info.light',
                                borderRadius: 1,
                                color: 'info.dark'
                            }}
                        >
                            {i18n.t('scheduleDeactivation.currentlyScheduled')}:{' '}
                            {moment(item.scheduledDeactivationDate).format(
                                'DD/MM/YYYY HH:mm'
                            )}
                        </Typography>
                    )}

                    <LocalizationProvider
                        dateAdapter={AdapterMoment}
                        adapterLocale={locale}
                    >
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                {i18n.t('scheduleDeactivation.date')}
                            </Typography>
                            <DatePicker
                                sx={{ width: '100%' }}
                                value={scheduledDeactivationDate}
                                onChange={this.handleScheduleDateChange}
                                minDate={moment()}
                            />
                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                {i18n.t('scheduleDeactivation.time')}
                            </Typography>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                    alignItems: 'flex-end'
                                }}
                            >
                                <TextField
                                    select
                                    value={
                                        scheduledDeactivationTime
                                            ? scheduledDeactivationTime
                                                  .hour()
                                                  .toString()
                                                  .padStart(2, '0')
                                            : '00'
                                    }
                                    onChange={(e) =>
                                        this.handleScheduleTimeChange(
                                            'hours',
                                            e.target.value
                                        )
                                    }
                                    disabled={!scheduledDeactivationDate}
                                    sx={{ width: '80px' }}
                                >
                                    {Array.from({ length: 24 }, (_, i) =>
                                        i.toString().padStart(2, '0')
                                    ).map((hour) => (
                                        <MenuItem key={hour} value={hour}>
                                            {hour}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <Typography sx={{ mx: 0.5 }}>:</Typography>
                                <TextField
                                    select
                                    value={
                                        scheduledDeactivationTime
                                            ? scheduledDeactivationTime
                                                  .minute()
                                                  .toString()
                                                  .padStart(2, '0')
                                            : '00'
                                    }
                                    onChange={(e) =>
                                        this.handleScheduleTimeChange(
                                            'minutes',
                                            e.target.value
                                        )
                                    }
                                    disabled={!scheduledDeactivationDate}
                                    sx={{ width: '80px' }}
                                >
                                    {['00', '15', '30', '45'].map((minute) => (
                                        <MenuItem key={minute} value={minute}>
                                            {minute}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>
                        </Box>
                    </LocalizationProvider>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={this.handleScheduleDeactivationClose}>
                        {i18n.t('buttons.cancel')}
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            // Clear date picker only
                            this.setState({
                                scheduledDeactivationDate: null,
                                scheduledDeactivationTime: null
                            });
                        }}
                        disabled={isSavingSchedule}
                        sx={{ mr: 1 }}
                    >
                        {i18n.t('scheduleDeactivation.clear')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={this.handleScheduleDeactivationSave}
                        disabled={
                            !scheduledDeactivationTime || isSavingSchedule
                        }
                    >
                        {isSavingSchedule ? (
                            <CircularProgress size={20} />
                        ) : (
                            i18n.t('buttons.save')
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
